// Lock at first kickoff on June 15 — England vs Serbia 19:00 UTC
export const WC_LOCK_DATE = new Date('2026-06-15T19:00:00Z');

export interface WcLockState {
  isLocked: boolean;
  label: string;        // human-readable countdown or locked message
  urgency: 'normal' | 'soon' | 'locked';
}

export function getWcLockState(): WcLockState {
  const now = Date.now();
  const lockTime = WC_LOCK_DATE.getTime();

  if (now >= lockTime) {
    return {
      isLocked: true,
      label: 'Tournament has started — predictions are locked',
      urgency: 'locked',
    };
  }

  const diff = lockTime - now;
  const days  = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const mins  = Math.floor((diff % 3_600_000) / 60_000);

  if (days > 0) {
    return {
      isLocked: false,
      label: `Locks in ${days}d ${hours}h — at first kickoff on June 15`,
      urgency: 'normal',
    };
  }
  if (hours > 0) {
    return {
      isLocked: false,
      label: `Locks in ${hours}h ${mins}m — closing very soon!`,
      urgency: 'soon',
    };
  }
  return {
    isLocked: false,
    label: `Locks in ${mins} minute${mins !== 1 ? 's' : ''} — closing now!`,
    urgency: 'soon',
  };
}
